import { Outlet } from "react-router-dom";

const TasksLayout = () => {
  return (
    <div className="tasks__layout flex h-full w-full overflow-hidden">
      <div className="tasks__outlet w-full flex-1">
        <Outlet />
      </div>
    </div>
  );
};

export default TasksLayout;
